export function Minus(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon / Minus / Standart">
          <path
            id="Icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.59998 24C1.59998 22.7574 2.54437 21.7353 3.75459 21.6124L3.99998 21.6L44 21.6C45.3255 21.6 46.4 22.6745 46.4 24C46.4 25.2426 45.4556 26.2647 44.2454 26.3876L44 26.4H3.99998C2.67449 26.4 1.59998 25.3255 1.59998 24Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  );
}
